import React from 'react';

const ArrowNarrowDown = props => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 17l-4 4m0 0l-4-4m4 4V3"
    />
  </svg>
);

export default ArrowNarrowDown;
